import { makeStyles, Theme } from '@material-ui/core'
import { createStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerLg: {
      backgroundColor: '#ffff',
      position: 'fixed',
      display: 'flex',
      justifyContent: 'space-between',
      zIndex: 1400,
      width: 'calc(100% - 260px)',
      marginLeft: '260px',
      height: '64px',
      [theme.breakpoints.up('lg')]: {
        width: '81%',
        marginLeft: '19%',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    headerTopLg: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        width: '150px',
        display: 'block',
        margin: '0 auto',
        paddingLeft: '10px',
      },
    },
    headerLgLeft: {
      width: '15%',
      lineHeight: '60px',
      marginLeft: '32px',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    headerLgRight: {
      width: '85%',
      display: 'flex',
      justifyContent: 'flex-end',
      lineHeight: '60px',
      alignItems: 'center',
      '& > *': {
        margin: '0 5px',
        marginLeft: theme.spacing(1),
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    languageButton: {
      fontSize: theme.variables.fontSizeMd,
      fontWeight: theme.variables.fontWeight600,
      color: theme.variables.deepBlue,
      textAlign: 'center',
      border: '1px solid #153C7B',
      borderRadius: '8px',
      paddingLeft: '12px',
      paddingTop: '8px',
      paddingBottom: '8px',
      width: '150px',
      height: '38px',
      marginRight: '10px',
      '&:hover': {
        borderRadius: '20px',
        color: '#FFFFFF',
        backgroundColor: theme.variables.allBlue,
        fontWeight: theme.variables.fontWeight500,
      },
      '& .MuiSelect-select.MuiSelect-select': {
        paddingRight: '32px',
        background: 'transparent',
      },
      '& .MuiSelect-icon': {
        top: 'auto',
      },
    },
    headerStatusList: {
      width: 'auto',
      justifyContent: 'center',
      padding: theme.spacing(1),
    },
    headerStatusItem: {
      fontSize: theme.variables.fontSizeMd,
      fontWeight: theme.variables.fontWeight600,
      fontColor: theme.variables.allBlue,
      alignContent: 'center',
      marginLeft: theme.spacing(1),
      border: '1px solid #153C7B',
      borderRadius: '8px',
      height: '38px',
      padding: '8px 12px',
      '&:hover': {
        borderRadius: '20px',
        color: '#FFFFFF',
        backgroundColor: theme.variables.allBlue,
        fontWeight: theme.variables.fontWeight500,
      },
      '& a': {
        color: 'inherit',
        textDecoration: 'none',
      },
    },
    appBar: {
      display: 'flex',
      height: '64px',
      boxShadow: 'none',
      backgroundColor: '#153C7B',
      [theme.breakpoints.up('md')]: {
        width: 'calc(100% - 260px)',
        marginLeft: '260px',
      },
      [theme.breakpoints.up('lg')]: {
        boxShadow: '0px 4px 16px rgba(38, 100, 223, 0.05)',
        backgroundColor: '#FFFFFF',
      },
    },
    menuButton: {
      position: 'absolute',
      color: '#ffff',
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    redDot: {
      color: 'white',
      height: '20px',
      width: '20px',
      padding: '-6px -6px',
      margin: '2px 4px',
      backgroundColor: '#D10000',
      borderRadius: '50%',
      textAlign: 'center',
      lineHeight: '20px',
      fontSize: theme.variables.fontSizeMd,
      display: 'inline-block',
    },
  }),
)

export default useStyles
